import { Hidden } from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCurrentFunctionName } from '../../performanceModeManager';
import InvoicesAsCards from './InvoicesAsCards';
import InvoicesAsTable from './InvoicesAsTable';

class InvoicesList extends Component {

    render() {
        console.perfLog(getCurrentFunctionName());

        let bigScreenElement = <InvoicesAsTable {...this.props} />;

        if (!this.props.invoices.displayAsList)
            bigScreenElement = <InvoicesAsCards {...this.props} />

        return (
            <>
                <Hidden only={['xl', 'lg', 'md']}>
                    <InvoicesAsCards {...this.props} />
                </Hidden>
                <Hidden only={['sm', 'xs']}>
                    {bigScreenElement}
                </Hidden>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        invoices: state.invoices,
    };
};

const mapDispatchToProps = () => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesList);
